import { createContext, useContext, useEffect, useState } from "react";

import { Permission } from "@/Common/Api/Employee/Dto/Permission";
import { OnClickAction, TriStateCheckboxControl } from "@/Common/Components/Inputs/TriStateCheckboxControl";
import { EnumHelper } from "@/Common/Helpers/EnumHelper";
import { EnumMyleLoginPermission } from "@/Common/Models/EnumMyleLoginPermission";

import styles from "./PermissionSettingsSectionComponent.module.scss";

interface IPermissionSettingsComponentContext {
    disabled: boolean;
    onPermissionCheckChange: (isChecked: boolean, permission: Permission[]) => void;
    permissionIds?: string[];
}

interface PermissionCheckBoxComponentProps {
    permission: Permission;
    isTitle?: boolean;
    permissionDescription?: string;
    dataCy?: string;
}

const PermissionSettingsComponentContext = createContext<IPermissionSettingsComponentContext>({
    disabled: true,
    onPermissionCheckChange: null,
    permissionIds: null
});

function PermissionCheckBoxComponent(props: PermissionCheckBoxComponentProps): JSX.Element {
    const { permissionIds, onPermissionCheckChange, disabled } = useContext(PermissionSettingsComponentContext);

    const [isChecked, setIsChecked] = useState<boolean>();

    useEffect(() => {
        setIsChecked(permissionIds?.some(p => p === props.permission.Id));
    }, [permissionIds, props.permission.Id]);

    const label = (
        <>
            {props.isTitle
                ? <h4>{EnumHelper.getVocab(EnumMyleLoginPermission, "Enums_EnumMyleLoginPermission_", props.permission.Name)}</h4>
                : <p>{EnumHelper.getVocab(EnumMyleLoginPermission, "Enums_EnumMyleLoginPermission_", props.permission.Name)}</p>
            }
            {props.permissionDescription && <p>{props.permissionDescription}</p>}
        </>
    );

    return (
        <div className={props.isTitle ? styles.parentCheckbox : styles.childrenCheckbox} data-cy={props.dataCy}>
            <TriStateCheckboxControl
                id={props.permission.Id}
                onClick={action => onPermissionCheckChange(action === OnClickAction.SelectAll, [props.permission])}
                checkedStates={[isChecked]}
                disabled={disabled}
                label={label}
            />
        </div>
    );
}

export { IPermissionSettingsComponentContext, PermissionCheckBoxComponent, PermissionSettingsComponentContext };
